import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable({ providedIn: 'root' })
export class ExpiredFundDialogService {
  private dialog = inject(MatDialog);

  open(fundName: string, mailTo?: string): void {
    this.dialog.open(ConfirmationDialogComponent, {
      width: '512px',
      maxWidth: '90vw',
      panelClass: ['confirmation-dialog-container'],
      data: {
        actionType: 'confirm',
        layout: 'detailed',
        title: 'fund.expired.title',
        description: 'fund.expired.message',
        params: { fund: fundName, email: mailTo },
        confirmButtonText: 'common.ok',
        hideCancelButton: true,
      },
    });
  }
}
